import React from 'react';
import OfferListing from './OfferListing';
import {
    ApolloProvider,
    ApolloClient,
    InMemoryCache,
    createHttpLink,
    ApolloLink,
    Observable,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_API_URL as string
})

const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            'Authorization': process.env.REACT_APP_API_AUTH_KEY as string,
            'x-ad2cart-campaign-uuid': process.env.REACT_APP_CAMPAIGN_UUID as string
            // @todo the campaign UUID should be a dynamic value
        }
    }
})

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
})

// Delay Link for testing
const delayInMS = 2000;
const delayLink = new ApolloLink((operation, forward) =>
    new Observable(observer => {
        let handle: any
        new Promise((resolve) => {
            setTimeout(() => {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }, delayInMS)
        })

        return () => {
            if (handle) handle.unsubscribe();
        }
    })
)

// Client with Delay
const clientWithDelay = new ApolloClient({
    link: delayLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
});

const App: React.FC = () => {
    return (
        <ApolloProvider client={client}>
            <ApolloProvider client={clientWithDelay}>
                <OfferListing />
            </ApolloProvider>
        </ApolloProvider>
    );
}

export default App;